<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="TOK-tv-pass---smartphone" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Team-Pass---Searching-03" transform="translate(-317.000000, -45.000000)">
        <g id="close" transform="translate(312.000000, 40.000000)">
          <rect id="bounds" x="0" y="0" width="24" height="24"></rect>
          <polygon id="ExitGlyphs" points="19 6.4 17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12"></polygon>
        </g>
      </g>
    </g>
  </svg>
</template>
<script lang="js">
export default {
  name: 'Exit',
};
</script>
